import { CardHeader } from "reactstrap";
import { DashboardCommonHeaderType } from "../../../Types/CommonComponentsType";
import { CommonDropdown } from "../CommonDropdown/CommonDropdown";
import { H4 } from "../../../AbstractElements";

const DashboardCommonHeader: React.FC<DashboardCommonHeaderType> = ({ title, tagClass, dropDownFalse, children, dropdownTitle, dropdownClass ,text}) => {
  return (
    <CardHeader className="pb-0">
      <div className="header-top">
        <H4 className={tagClass ? tagClass : ""}>{title} {text && <span className="f-14 f-w-500 ms-1 f-light">{text}</span>}</H4>
        {!dropDownFalse && <CommonDropdown dropdownTitle={dropdownTitle} dropdownClass={dropdownClass} />}
        {children}
      </div>
    </CardHeader>
  );
};

export default DashboardCommonHeader;
